import axios from "axios"
import configData from "../config.json"

export default function saveLead() {
    const headers = {
        'Access-Control-Allow-Origin': '*',
        'origin': 'x-requested-with',
        'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
        'Content-Type': 'application/json',
    }
    const data = sessionStorage.getItem('lead')
    const dataInfo = sessionStorage.getItem('leadInfo')
    
    axios.post(`${configData.API_URL}/data/insertLeadStep?lead=` + data + `&leadLog=` + dataInfo + `&personId=` + JSON.parse(data).M12CED, { headers })
        .then(response => console.log(response))


} 